/* eslint-disable no-dupe-keys */
export default {
  group_transaction_record: {
    name: '集团交易记录',
    // 属性（一般与对象内容匹配）
    prop: {
      amount: '金额',
      description: '说明',
      admin_password: '身份认证'
    },
    placeholders: {
      input_description: '输入收据单号 或者 其他备注',
      input_admin_password: '输入登录密码确认身份'
    },
    titles: {
      topup: '充值',
      withdraw: '提现'
    },
    btn: {
      topup: '充值',
      withdraw: '提现'
    },
    labels: {
      max_withdraw_amount: '可提现金额 {0} 元'
    }
  }
}
